import * as React from 'react';
import moment from 'moment';
import isNil from 'lodash/isNil';
import { connect } from 'react-redux';

import DatePickerMulti from 'components/date-picker/date-picker-multi/DatePickerMulti';
import InputArray from 'components/inputs/input-array/InputArray';


import {
  changeDateRangeAction,
  updateSearchByAction,
  updateStorySnippetsList
} from '../../redux/actions';

import { __t, applyTranslations } from 'utils/language';

import './select-story-snippets-filters.scss';

applyTranslations(require('./select-story-snippets-filters.i18n.json'));

import { State } from 'types';
import { DateRange } from '../../types';

interface StateProps {
  campaignStartDate: null | string,
  dates: DateRange,
  keywords: Array<string>
}

interface DispatchProps {
  dispatchChangeDates: (dates: DateRange) => void,
  dispatchUpdateKeywords: (keywords: Array<string>) => void,
  dispatchOnUpdate: () => void
}

type Props = StateProps & DispatchProps;

const SelectStorySnippetsFilters = ({
  campaignStartDate,
  dates,
  keywords,
  dispatchChangeDates,
  dispatchUpdateKeywords,
  dispatchOnUpdate
}: Props): JSX.Element => {
  const isMounted = React.useRef(false);

  React.useEffect(() => {
    if (isMounted.current) {
      dispatchOnUpdate();
    }

    isMounted.current = true;
  }, [dates, keywords]);

  return (
    <div className="select-story-snippets-filters">
      <div className="select-story-snippets-filters__container">
        <span className="select-story-snippets-filters__filter-title">
          {__t('select_story_snippets_filters.dates')}
        </span>
        <div>
          <DatePickerMulti
            noFutureDates
            noPastDates={false}
            startDate={dates[0]}
            endDate={dates[1]}
            isDayBlocked={(date: moment.Moment) => {
              if (isNil(campaignStartDate)) {
                return false;
              }

              return date.isBefore(campaignStartDate);
            }}
            onChange={(start, end) => dispatchChangeDates([start, end])}
          />
        </div>
      </div>
      <div className="select-story-snippets-filters__container">
        <span className="select-story-snippets-filters__filter-title">
          {__t('select_story_snippets_filters.keywords')}
        </span>
        <div className="select-story-snippets-filters__input">
          <InputArray
            name="select-story-snippets-keywords"
            value={keywords}
            placeholder={__t('select_story_snippets_filters.placeholder')}
            onChange={dispatchUpdateKeywords}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ selectStorySnippets }: State): StateProps => ({
  campaignStartDate: selectStorySnippets.campaignStartDate,
  dates: selectStorySnippets.dates,
  keywords: selectStorySnippets.searchBy
});

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchChangeDates: dates => dispatch(changeDateRangeAction(dates)),
  dispatchUpdateKeywords: keywords => dispatch(updateSearchByAction(keywords)),
  dispatchOnUpdate: () => dispatch(updateStorySnippetsList())
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectStorySnippetsFilters);
